import React, { useState } from 'react';
import ChatListContainer from './ChatListContainer';
import ChatBox from './ChatBox';

const ChatWindow = () => {
  // State to manage the selected chat
  const [selectedChat, setSelectedChat] = useState(0);
  const chatData = [
    { senderOnlineStatus: true, senderImage: 'https://primefaces.org/cdn/primereact/images/organization/walter.jpg', senderName: 'User 123', message: 'hy hello, how are you?', lastSeen: '2d' },
    { senderOnlineStatus: true, senderImage: 'https://primefaces.org/cdn/primereact/images/organization/walter.jpg', senderName: 'Ajas A S', message: 'hello, how are you?', lastSeen: '2d' },
    { senderOnlineStatus: false, senderImage: 'https://primefaces.org/cdn/primereact/images/organization/walter.jpg', senderName: 'Test', message: 'test message?', lastSeen: '2d' },
    { senderOnlineStatus: true, senderImage: 'https://primefaces.org/cdn/primereact/images/organization/walter.jpg', senderName: 'User 123', message: 'hy hello, how are you?', lastSeen: '2d' },
    { senderOnlineStatus: true, senderImage: 'https://primefaces.org/cdn/primereact/images/organization/walter.jpg', senderName: 'User 123', message: 'hy hello, how are you?', lastSeen: '2d' },
  ];

  const handleChatClick = (index) => {
    setSelectedChat(index);
  };

  return (
    <div className="flex flex-column md:flex-row gap-5" style={{ minHeight: '50vh' }}>
      <ChatListContainer chatData={chatData} selectedChat={selectedChat} handleChatClick={handleChatClick} />
      <ChatBox chat={chatData[selectedChat]} />
    </div>
  );
};

export default ChatWindow;
